<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
     
     
      <v-tab @change="changetab('Card + Event - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       EVENT SETTING
      </v-tab>

    
     
      <v-tab-item style="background-color:#e9e9e9;">
       <EventSetting></EventSetting>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import EventSetting from '../../../components/EventSetting.vue'
export default {
 components: {EventSetting},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>